import ThreeViewer from "components/three/ThreeViewer";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { postCreate3DModel } from "lib/api/postCreateThreeDModel";
import {
  parseFramesTxt,
  parseImagesTxt,
  parsePoints3D,
} from "lib/utils/txtParseTo3D";
import Spinner from "components/Spinner";

export default function VideoThreeDPanel({
  upload_status,
  upload_id,
  fetchGetFile,
  plyUrl,
  textureUrl,
  framesUrl,
  imagesUrl,
  points3DUrl,
}) {
  const { t } = useTranslation();
  const [frames, setFrames] = useState(null);
  const [images, setImages] = useState(null);
  const [points3D, setpoints3D] = useState(null);
  const [isLoadingSfm, setIsLoadingSfm] = useState(false);
  const [isSpinner, setIsSpinner] = useState(false);

  // 🔥 SfM txt 불러오기
  useEffect(() => {
    if (upload_status !== 2) return;

    async function loadSfmData() {
      try {
        setIsLoadingSfm(true);

        const framesTxt = await fetch(framesUrl).then((r) => r.text());
        const imagesTxt = await fetch(imagesUrl).then((r) => r.text());
        const points3DTxt = await fetch(points3DUrl).then((r) => r.text());

        setFrames(parseFramesTxt(framesTxt));
        setImages(parseImagesTxt(imagesTxt));
        setpoints3D(parsePoints3D(points3DTxt));
      } catch (err) {
        console.error("SfM load error:", err);
      } finally {
        setIsLoadingSfm(false);
      }
    }

    loadSfmData();
  }, [upload_status, framesUrl, imagesUrl, points3DUrl]);

  // 🔥 3D 생성 요청 핸들러
  const handleCreate3D = async () => {
    setIsSpinner(true);
    await postCreate3DModel(upload_id);
    await fetchGetFile();
    setIsSpinner(false);
  };

  // ================================
  // ⭕ 0 or null → 생성 전
  // ================================
  if (!upload_status) {
    return (
      <section className="threeDPanel">
        <button onClick={handleCreate3D} className="create3D-btn">
          {t("videoFileIndex.threeD.createModel")}
        </button>
        {isSpinner && <Spinner />}
      </section>
    );
  }

  // ================================
  // ⭕ 1 → 생성 중
  // ================================
  if (upload_status === 1) {
    return (
      <section className="threeDPanel">
        <button className="create3D-btn loading" disabled>
          <span className="loading-text">
            {t("videoFileIndex.threeD.creatingModel")}
          </span>
        </button>
      </section>
    );
  }

  // ================================
  // ⭕ 2 → 생성 완료 BUT SFM 데이터 미완료
  // ================================
  if (
    upload_status === 2 &&
    (isLoadingSfm || !frames || !images || !points3D)
  ) {
    return (
      <section className="threeDPanel">
        <p>{t("videoFileIndex.threeD.dataLoading")}</p>
      </section>
    );
  }

  // ================================
  // ⭕ 2 → 생성 & SfM 데이터 준비 완료
  // ================================
  if (upload_status === 2) {
    return (
      <section className="threeDPanel">
        <ThreeViewer
          plyUrl={plyUrl}
          textureUrl={textureUrl}
          frames={frames}
          images={images}
          points3D={points3D}
        />
      </section>
    );
  }

  // ================================
  // 예외
  // ================================
  return (
    <section className="threeDPanel">
      <p>
        {t("videoFileIndex.threeD.unknownStatus", { status: upload_status })}
      </p>
    </section>
  );
}
